import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $SharingCurrentTraffic } from 'shared/atoms';
import { $CurrentUserAsAvailable } from '@user/shared/current-user';
import { useDeepLink, SHARING_FB_PID } from '~/utils/active';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const UserFacebook: FC = () => {
  const { canonicalUrl } = useAtomValue($SharingCurrentTraffic);
  const user = useAtomValue($CurrentUserAsAvailable);

  const openUrl = useDeepLink({
    pid: SHARING_FB_PID,
    pageType: 'user',
    userId: user.userId,
  });

  return (
    <DynamicHead>
      <meta property="al:ios:url" content={openUrl} />
      <meta property="al:ios:app_store_id" content="1498607143" />
      <meta property="al:ios:app_name" content="Lemon8" />
      <meta property="al:android:url" content={openUrl} />
      <meta property="al:android:app_name" content="Lemon8" />
      <meta property="al:android:package" content="com.bd.nproject" />
      <meta property="al:web:url" content={canonicalUrl} />
    </DynamicHead>
  );
};
